import DynamicFormPicklistItemDefinitionResourceModel from '../../generated/types/model/resource/DynamicFormPicklistItemDefinitionResourceModel';

export default class DynamicFormPicklistItemDefinitionResourceViewModel extends DynamicFormPicklistItemDefinitionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
